<template>
	<div class="product-detail">
		<OverlayProduct
			v-if="code"
			:code="code"
			@shop="goToShop"
		/>

		<div class="product-detail__share">
			<h3
				class="product-detail__share-title"
				v-html="$t('shoplist.product.share.title')"
			/>
			<ShareButtons
				class="product-detail__share-buttons"
				:url="url"
				:email-subject="emailSubject"
				:email-text="emailText"
				:whatsapp-text="whatsappText"
				:facebook-text="facebookText"
				:twitter-text="twitterText"
			/>
		</div>

	</div>
</template>

<script>
import OverlayProduct from '@/pages/OverlayProduct';
import ShareButtons from '@/components/ShareButtons'
import { getUrlParams } from '@/utils/urlParams';
import GenericMixin from '@/mixins/GenericVueMixin'

export default {
  mixins: [
    GenericMixin,
  ],
	components: {
		OverlayProduct,
		ShareButtons
	},
	data() {
		return {
			code: null,
			url: location.origin + location.pathname
		};
	},
	computed: {
		facebookText() {
			return this.$t('shoplist.product.share.facebookText', { url: this.url, brand: this.$t(`brands.${this.themeName}`) }).replace(/\\n/ig, '\n');
		},
		twitterText() {
			return this.$t('shoplist.product.share.whatsappText', { url: this.url, brand: this.$t(`brands.${this.themeName}`) }).replace(/\\n/ig, '\n');
		},
		whatsappText() {
			return this.$t('shoplist.product.share.whatsappText', { url: this.url, brand: this.$t(`brands.${this.themeName}`) }).replace(/\\n/ig, '\n');
		},
		emailText() {
			return this.$t('shoplist.product.share.emailText', { url: this.url, brand: this.$t(`brands.${this.themeName}`) }).replace(/\\n/ig, '\n');
		},
		emailSubject() {
			return this.$t('shoplist.product.share.emailSubject', { brand: this.$t(`brands.${this.themeName}`) });
		},
	},
	methods: {
		goToShop() {
			this.$store.dispatch('redirect', { name: 'shop-product', params: { product: this.code }, force: true})
		}
	},
	async created() {
		this.loading = true;
		const { product } = getUrlParams();

		if (product) {
			this.code = product;
		}
		else if (this.$root.options.code) {
			this.code = this.$root.options.code;
		}

		this.loading = false;
	},
}
</script>

<style>

</style>
